import Navigation from '../../components/feature/Navigation';
import Footer from '../../components/feature/Footer';
import ServicesHero from './components/ServicesHero';
import ServicesIntro from './components/ServicesIntro';
import ServiceCategories from './components/ServiceCategories';
import MarketsWeServe from './components/MarketsWeServe';
import ServicesCTA from './components/ServicesCTA';

export default function ServicesPage() {
  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <ServicesHero />
      <ServicesIntro />
      <ServiceCategories />
      <MarketsWeServe />
      <ServicesCTA />
      <Footer />
    </div>
  );
}